import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  withIcon?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'lg',
  fullWidth = false,
  withIcon = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-xl font-bold transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#F4A261] text-[#1B4332] hover:bg-[#E9C46A] hover:shadow-lg hover:scale-[1.02] focus:ring-[#F4A261]',
    secondary: 'bg-[#2D6A4F] text-white hover:bg-[#1B4332] hover:shadow-lg hover:scale-[1.02] focus:ring-[#2D6A4F]',
    outline: 'border-2 border-[#2D6A4F] text-[#2D6A4F] hover:bg-[#2D6A4F] hover:text-white focus:ring-[#2D6A4F]'
  };
  const sizes = {
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl'
  };
  const width = fullWidth ? 'w-full' : '';
  return <motion.button whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${width} ${className}`} {...props} data-id="element-76">
      {children}
      {withIcon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-77" />}
    </motion.button>;
}